export default __webpack_public_path__ + "images/loading.5ca0dd92aa1fd276533f520d32a7ed3c.gif";